/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import {API_UPLOADS} from "../../api";
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

const Screen = ({loading, error}) => {

    const [data, set_data] = useState(null);

    const [pagination_active, set_pagination_active] = useState(1);

    const _read = (pages) => {

        let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (12 * pages) - 12 : 0
        
        }
        
        loading(true);

        API_GET_PUBLIC(`client/images__________?limit=12&offset=${offsetSync}`)
        .then((response) => {
            if(response.data.result === 'success'){
                console.log('data', response.data.data)
                loading(false)
                set_data(response.data.data)
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    
    useEffect(() => {
        
		_read()

    }, [])

	return (
		<>
            <Helmet>

                <meta name="description" content={'Images'}/>
                <title>{'Images'}</title>

            </Helmet>

            <div className="_container">
                <div className="_lily_pad_h_d __section_pages_title">
                    <h1>Images</h1>
                </div>
            </div>
            <div className="_container">
                <div className="_row_sync" style={{alignItems: 'center'}}>
                    <Gallery>
                        {
                            data ?
                                data.list.map((item, index) => {
                                    return (
                                        <Item
                                            key={index}
                                            original={API_UPLOADS + item.image}
                                            thumbnail={API_UPLOADS + item.image}
                                            width="1024"
                                            height="768"
                                            title={item.title}
                                        >
                                            {({ ref, open }) => (
                                                <div className="_column_sync" style={{cursor: 'pointer'}}>
                                                    <img ref={ref} onClick={open} src={API_UPLOADS + item.image} />
                                                </div>
                                            )}
                                        </Item>
                                    )
                                })
                            :
                                <>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                    <div className="_column_sync">
                                        <div style={{height: 200, backgroundColor: '#eee'}}/>
                                    </div>
                                </>
                        }
                    </Gallery>
                </div>
            </div>
            <div className="_container">
                <div className="_lily_pad_h_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div>
            </div>
		</>
	);
}

export default Screen;